'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { Fm, Dm, Im, Pm } from './techpack-schematic';
import { ShowcaseSpinner } from './playback-controls';
import { T } from './workflow-facts';
import { ef } from './sell-market-animation';
import { Me } from './reference-brands';
export function MeasurementTable({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <table className={'w-full border-separate border-spacing-0'}>
      <thead>
        <tr>
          <th className={`${Fm} w-10`}>
            {translateShowcaseNode(showcaseCopy, 'POM')}
          </th>
          <th className={Fm}>
            {translateShowcaseNode(showcaseCopy, 'Description')}
          </th>
          <th className={`${Fm} text-right`}>
            {translateShowcaseNode(showcaseCopy, 'cm')}
          </th>
          <th className={`${Fm} text-right`}>
            {translateShowcaseNode(showcaseCopy, 'Tol \xB1')}
          </th>
        </tr>
      </thead>
      <tbody className={'num'}>
        {translateShowcaseNode(
          showcaseCopy,
          Dm.map((t) => {
            let n = e >= t.at + 300;
            return (
              <tr key={t.code} data-on={String(e >= t.at)} className={'pd-in'}>
                <td className={`${Im} text-ink font-mono font-semibold`}>
                  {translateShowcaseNode(showcaseCopy, t.code)}
                </td>
                <td className={`${Im} text-ink-2`}>
                  {translateShowcaseNode(showcaseCopy, t.name)}
                </td>
                <td className={`${Im} text-ink text-right font-mono`}>
                  {translateShowcaseNode(
                    showcaseCopy,
                    n ? (
                      <span className={'swap-in'}>
                        {translateShowcaseNode(showcaseCopy, t.cm)}
                      </span>
                    ) : (
                      <ShowcaseSpinner
                        className={'text-ink-4 ml-auto size-3'}
                      />
                    )
                  )}
                </td>
                <td className={`${Im} text-ink-3 text-right font-mono`}>
                  {translateShowcaseNode(showcaseCopy, n ? t.tol : '')}
                </td>
              </tr>
            );
          })
        )}
        <tr
          data-on={String(e >= (Dm[Dm.length - 1]?.at ?? 0) + 500)}
          className={'pd-in'}
        >
          <td
            colSpan={4}
            className={
              'text-ink-3 h-9 border-b border-[var(--line)] px-2 text-[12.5px]'
            }
          >
            <span className={'num font-mono'}>
              {translateShowcaseNode(showcaseCopy, '+')}
              {translateShowcaseNode(showcaseCopy, T.measurements - Dm.length)}
            </span>
            {translateShowcaseNode(showcaseCopy, ' ')}
            {translateShowcaseNode(
              showcaseCopy,
              'more, each with a target, tolerance and verification method'
            )}
          </td>
        </tr>
      </tbody>
    </table>
  );
}
export const Rm = [
  {
    part: 'Body and gusset',
    material: 'Full-grain vegetable-tanned calf, 1.80 \xB10.15 mm',
    qty: '1 set',
  },
  {
    part: 'Handles',
    material: 'Flat calf straps, edge-painted',
    qty: '2',
  },
  {
    part: 'Base',
    material: 'Welted construction',
    qty: '1',
  },
  {
    part: 'Closure',
    material: 'Concealed magnet pairs',
    qty: '2',
  },
  {
    part: 'Lining',
    material: 'TBD',
    qty: '1 set',
  },
  {
    part: 'Edge paint',
    material: 'Matched to each colorway',
    qty: '\u2014',
  },
];
export const zm = 4300;
export const Bm = 230;
export function BillOfMaterials({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = ef(e, zm, Bm, Rm.length);
  return (
    <table className={'w-full border-separate border-spacing-0'}>
      <thead>
        <tr>
          <th className={`${Fm} w-8`}>
            {translateShowcaseNode(showcaseCopy, '#')}
          </th>
          <th className={Fm}>
            {translateShowcaseNode(showcaseCopy, 'Component and material')}
          </th>
          <th className={`${Fm} text-right`}>
            {translateShowcaseNode(showcaseCopy, 'Qty')}
          </th>
        </tr>
      </thead>
      <tbody>
        {translateShowcaseNode(
          showcaseCopy,
          Rm.map((n, r) => {
            let i = t > r,
              a = t > r + 1 || e >= 4300 + Rm.length * Bm;
            return (
              <tr key={n.part} data-on={String(i)} className={'pd-in'}>
                <td className={`${Im} num text-ink-4 font-mono text-[12px]`}>
                  {translateShowcaseNode(showcaseCopy, r + 1)}
                </td>
                <td className={`${Im} text-ink py-1.5 leading-5`}>
                  <span className={'block'}>
                    {translateShowcaseNode(showcaseCopy, n.part)}
                  </span>
                  <span
                    className={`block text-[12px] leading-4 whitespace-normal ${n.material === 'TBD' ? 'text-ink-4 font-mono' : 'text-ink-3'}`}
                  >
                    {translateShowcaseNode(showcaseCopy, n.material)}
                  </span>
                </td>
                <td className={`${Im} num text-ink text-right font-mono`}>
                  {translateShowcaseNode(
                    showcaseCopy,
                    a ? (
                      n.qty
                    ) : (
                      <ShowcaseSpinner
                        className={'text-ink-4 ml-auto size-3'}
                      />
                    )
                  )}
                </td>
              </tr>
            );
          })
        )}
        <tr data-on={String(e >= zm + Rm.length * Bm)} className={'pd-in'}>
          <td
            colSpan={3}
            className={
              'text-ink-3 h-9 border-b border-[var(--line)] px-2 text-[12.5px]'
            }
          >
            <span className={'num font-mono'}>
              {translateShowcaseNode(showcaseCopy, '+')}
              {translateShowcaseNode(showcaseCopy, T.bomItems - Rm.length)}
            </span>
            {translateShowcaseNode(showcaseCopy, ' ')}
            {translateShowcaseNode(showcaseCopy, 'more items')}
          </td>
        </tr>
      </tbody>
    </table>
  );
}
export const Hm = Me.orvieto[0] ?? '#F3EDE3';
export const Um = Me.orvieto[1] ?? '#B9A98F';
export const Wm = Me.orvieto[2] ?? '#8A4B2D';
export const Gm = Me.orvieto[3] ?? '#3E4A3D';
export const Km = Me.orvieto[4] ?? '#1F1A17';
export const qm = [
  {
    name: 'Cognac',
    body: Wm,
    edge: Pm(Wm),
    thread: Um,
    lining: Hm,
  },
  {
    name: 'Ink',
    body: Km,
    edge: Km,
    thread: Pm(Km, 1.6),
    lining: Um,
  },
  {
    name: 'Olive',
    body: Gm,
    edge: Pm(Gm),
    thread: Um,
    lining: Hm,
  },
];
export const Jm = [
  {
    key: 'body',
    label: 'Body and handles',
  },
  {
    key: 'edge',
    label: 'Edge paint',
  },
  {
    key: 'thread',
    label: 'Thread',
  },
  {
    key: 'lining',
    label: 'Lining',
  },
];
export const Ym = 6500;
export function ColorwayTable({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = ef(e, Ym, 260, qm.length);
  return (
    <table className={'w-full border-separate border-spacing-0'}>
      <thead>
        <tr>
          <th className={Fm}>
            {translateShowcaseNode(showcaseCopy, 'Component')}
          </th>
          {translateShowcaseNode(
            showcaseCopy,
            qm.map((e, n) => (
              <th key={e.name} className={`${Fm} text-center`}>
                <span data-on={String(t > n)} className={'pd-in inline-block'}>
                  {translateShowcaseNode(showcaseCopy, e.name)}
                </span>
              </th>
            ))
          )}
        </tr>
      </thead>
      <tbody>
        {translateShowcaseNode(
          showcaseCopy,
          Jm.map((e, n) => (
            <tr key={e.key}>
              <td className={`${Im} text-ink-2`}>
                {translateShowcaseNode(showcaseCopy, e.label)}
              </td>
              {translateShowcaseNode(
                showcaseCopy,
                qm.map((r, i) => (
                  <td key={r.name} className={`${Im} text-center`}>
                    <span
                      data-on={String(t > i)}
                      className={
                        'pd-pop inline-block size-5 rounded-full shadow-[inset_0_0_0_1px_rgb(0_0_0/0.12)]'
                      }
                      style={{
                        background: r[e.key],
                        transitionDelay: `${n * 60}ms`,
                      }}
                    />
                  </td>
                ))
              )}
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
}
export const Zm = [
  `Measurements · ${T.measurements}`,
  `BOM · ${T.bomItems}`,
  `Colorways · ${T.colorways.length}`,
];
export const Qm = ['Measurements', 'Bill of Materials', 'Colorways'];
export function EvidenceLegend() {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div
      className={
        'text-ink-2 inline-flex flex-col gap-1 rounded-[4px] px-2 py-1.5 text-[9.5px] leading-none tracking-[0.04em] shadow-[inset_0_0_0_1px_var(--border)] sm:text-[10px]'
      }
    >
      <span className={'flex items-center gap-2'}>
        <span className={'h-px w-5 bg-current'} />
        {translateShowcaseNode(showcaseCopy, 'SOURCE-SUPPORTED')}
      </span>
      <span className={'flex items-center gap-2'}>
        <span
          className={
            'h-px w-5 bg-[repeating-linear-gradient(90deg,currentColor_0_3px,transparent_3px_6px)]'
          }
        />
        {translateShowcaseNode(showcaseCopy, 'PROPOSAL')}
      </span>
    </div>
  );
}
